// Tiny theme singleton to keep design tokens centralized
class Theme {
  static #instance;
  tokens = {
    primary: '#0e5fb5',
    secondary: '#3f806e'
  };

  static getInstance() {
    if (!Theme.#instance) Theme.#instance = new Theme();
    return Theme.#instance;
  }

  setCSSVars() {
    const r = document.documentElement;
    r.style.setProperty('--primary-700', this.tokens.primary);
    r.style.setProperty('--secondary-500', this.tokens.secondary);
  }
}
export default Theme.getInstance();
